import React, { createContext, useContext } from 'react'

interface BookingSellerReservationsContextValue {
    tableInit: any
    isTableStateSame?: boolean
    onlineOnly?: boolean
    onRowClick?: (row: any) => void
}

const BookingSellerReservationsContext =
    createContext<BookingSellerReservationsContextValue | null>(null)

export const BookingSellerReservationsProvider = ({
    value,
    children,
}: {
    value: BookingSellerReservationsContextValue
    children: React.ReactNode
}) => {
    return (
        <BookingSellerReservationsContext.Provider value={value}>
            {children}
        </BookingSellerReservationsContext.Provider>
    )
}

export const useBookingSellerReservationsContext = () => {
    const context = useContext(BookingSellerReservationsContext)

    if (!context) {
        throw new Error(
            'useBookingSellerReservationsContext must be used within BookingSellerReservationsProvider'
        )
    }

    return context
}
